export const emailPattern: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/;

export function isValidEmail(email: string): boolean {
    if(!email) {
        return true;
    }

    if (email && emailPattern.test(email)) {
        return true;
    }

    return false;
}